"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectVariant = exports.RawSelect = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _react = _interopRequireDefault(require("react"));
var _rawSelect = require("./rawSelect.styles");
var _icon = require("../../icon/icon");
const _excluded = ["required", "hasError", "validationErrorId", "disabled", "insetIcon", "iconColor", "onSelectChange", "className", "variant", "inputId"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SelectVariant;
(function (SelectVariant) {
  SelectVariant["default"] = "default";
  SelectVariant["inverted"] = "inverted";
  SelectVariant["alternate"] = "alternate";
})(SelectVariant || (exports.SelectVariant = SelectVariant = {}));
const RawSelect = exports.RawSelect = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
      required,
      hasError,
      validationErrorId,
      disabled,
      insetIcon,
      iconColor,
      onSelectChange,
      className,
      variant = SelectVariant.default,
      inputId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return (0, _jsxRuntime.jsxs)(_rawSelect.SelectContainer, {
    hasError: hasError,
    disabled: disabled,
    hasIcon: !!insetIcon,
    className: className,
    children: [(0, _jsxRuntime.jsx)(_rawSelect.SelectElement, _objectSpread(_objectSpread({}, props), {}, {
      menuPosition: "fixed",
      menuPlacement: "auto",
      classNamePrefix: "react-select",
      onChange: onSelectChange,
      ref: ref,
      "aria-required": required,
      "aria-invalid": hasError,
      "aria-describedby": validationErrorId,
      variant: variant,
      inputId: inputId,
      isDisabled: disabled ?? undefined
    })), insetIcon && (0, _jsxRuntime.jsx)(_icon.FontIcon, {
      className: "select-error-icon",
      icon: insetIcon,
      primaryColor: iconColor
    })]
  });
});
RawSelect.displayName = 'RawSelect';